import {configTables} from "../../../global/configTables.js";
import {api} from "../../../global/framework/api.js";

export const consumerPaymentMethodMixin = {
    data() {
        return {
            ccVm: {},
            paymentTypes: [],
            paymentSettingsVm: {},
            hasSelectedPaymentOption: false
        }
    },
    computed: {
        showCreditCardSection() {
            return this.widgetReady &&
                (this.paymentSettingsVm.paymentTypeId === 1) ||//They already selected cc as the payment method
                (
                    !this.hasSelectedPaymentOption &&//They have not selected any option and they are allowed to select cc
                    !Boolean(this.paymentSettingsVm.paymentTypeId) &&
                    this.paymentSettingsVm.allowedToUseCreditCard
                )
        },
        showPaymentOptions() {
            return this.widgetReady && (
                !this.hasSelectedPaymentOption &&
                this.paymentSettingsVm.allowedToUsePayrollDeductions &&
                this.paymentSettingsVm.allowedToUseCreditCard
            );
        }
    },
    watch: {
        async showPaymentOptions(newValue) {
            if (newValue) {
                this.paymentTypes = await configTables.getPaymentTypes();
                this.paymentSettingsVm.paymentTypeId = this.paymentTypes[0].paymentTypeId;
            }
        }
    },
    methods: {
        async tryGettingCardData() {
            let paymentMethodId = await this.$refs.currentCCsComponent.getPaymentMethodId();
            let isNewDefault = await this.$refs.currentCCsComponent.getNewDefaultBool();
            if (paymentMethodId) {
                let data = {
                    currentCards: this.ccVm.currentCards,
                    updatedCard: this.ccVm.updatedCard,
                    consumerId: this.consumerId,
                    paymentTypeId: this.paymentSettingsVm.paymentTypeId
                };
                data.updatedCard.paymentMethodId = paymentMethodId;
                data.updatedCard.isNewDefault = isNewDefault;
                return data;
            }
            return null;
        }
    }
};